import { SaiQuickTourFormCoachStep } from 'app/ui/sai-quick-tour/sai-quick-tour-form-coach.types';

/** Guided walkthrough inside Add Department while the main tour is on that step. */
export const SAI_QUICK_TOUR_DEPARTMENT_FORM_COACH_STEPS: readonly SaiQuickTourFormCoachStep[] = [
    {
        id: 'dept-intro',
        titleKey: 'Tour · Meet the Add Department form',
        bodyKey:
            'We prefilled a demo department. Departments sit under a division and control who can use data sources and agents.',
    },
    {
        id: 'dept-division',
        titleKey: 'Tour · Choose Division',
        bodyKey:
            'Select the parent division. If you opened Add from a division’s +, that division is already selected.',
        fieldTourId: 'dept-field-division',
    },
    {
        id: 'dept-name',
        titleKey: 'Tour · Department Name',
        bodyKey:
            'Name the team that will own data and agents (for example Sales or Marketing). Demo value: “Demo Sales”.',
        fieldTourId: 'dept-field-name',
        sampleKey: 'Demo Sales',
    },
    {
        id: 'dept-save',
        titleKey: 'Tour · Save your department',
        bodyKey:
            'Click Add to create it — next you will connect a data source for this department.',
        fieldTourId: 'dept-field-submit',
    },
];
